export default __webpack_public_path__ + "static/media/more_actions_icon.5e11278b.svg";